module.exports = __webpack_public_path__ + "static/media/trashcan.1f9ca620.svg";